import { __rest, __assign } from 'tslib';
import React, { useState, useRef, useEffect } from 'react';
import clsx from 'clsx';
import { cssAlertWrapper, cssAlertWrapperBlock, cssIcon, cssDescWithCloseBtn, cssAlertTitle } from './index.css.js';

var alertTitles = {
    SUCCESS: 'Success:',
    ERROR: 'Error:',
    WARNING: 'Warning:',
    INFO: 'Informational:',
    ATTENTION: 'Attention:'
};
var AlertBase = function (_a) {
    var _b, _c;
    var white = _a.white, _d = _a.dismiss, dismiss = _d === void 0 ? 0 : _d, type = _a.type, float = _a.float, title = _a.title, hideTitle = _a.hideTitle, _e = _a.hideIcon, hideIcon = _e === void 0 ? false : _e, onClose = _a.onClose, className = _a.className, block = _a.block, children = _a.children, resetTimerOnMouseLeave = _a.resetTimerOnMouseLeave, divProps = __rest(_a, ["white", "dismiss", "type", "float", "title", "hideTitle", "hideIcon", "onClose", "className", "block", "children", "resetTimerOnMouseLeave"]);
    var _f = useState(false), isDismissCancelled = _f[0], setIsDismissCancelled = _f[1];
    var timerRef = useRef(null);
    useEffect(function () {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        if (!isDismissCancelled) {
            timerRef.current = setTimeout(function () {
                if (!isDismissCancelled && onClose && dismiss > 0) {
                    onClose();
                }
            }, (dismiss || 0) * 1000);
        }
    }, [dismiss, isDismissCancelled, onClose]);
    useEffect(function () {
        return function () {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);
    var handleMouseEnter = function () {
        if (!isDismissCancelled) {
            if (timerRef.current)
                clearTimeout(timerRef.current);
            setIsDismissCancelled(true);
        }
    };
    var handleMouseLeave = function () {
        if (isDismissCancelled && resetTimerOnMouseLeave) {
            setIsDismissCancelled(false);
        }
    };
    var getAlertTitleBasedOnType = function () {
        if (title)
            return title;
        switch (type) {
            case 'success':
                return alertTitles.SUCCESS;
            case 'error':
                return alertTitles.ERROR;
            case 'warning':
                return alertTitles.WARNING;
            case 'info':
                return alertTitles.INFO;
            case 'attention':
                return alertTitles.ATTENTION;
            default:
                return '';
        }
    };
    var alertColors = function (type) {
        switch (type) {
            case 'success':
                return '#16a237';
            case 'error':
                return '#f2171c';
            case 'warning':
                return '#f76c1f';
            case 'info':
                return '#1e8ae7';
            case 'attention':
                return '#1e8ae7';
            default:
                return '#f2171c';
        }
    };
    return (React.createElement("div", __assign({}, divProps, { onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, className: clsx(className, cssAlertWrapper, 'c-alert', "c-alert--".concat(type), (_b = {
                'c-alert--white': white,
                'c-alert--float': float
            },
            _b[cssAlertWrapperBlock] = block,
            _b)) }),
        !hideIcon && (React.createElement("div", { className: clsx(cssIcon, {
                'icon-16-alert-bold': ['info', 'attention'].includes(type || ''),
                'icon-16-warning-bold': type === 'error',
                'icon-16-success-bold': type === 'success',
                'icon-16-info-bold': type === 'warning'
            }), style: {
                color: alertColors(type)
            } })),
        React.createElement("span", { className: clsx('c-alert__desc', (_c = {},
                _c[cssDescWithCloseBtn] = !!onClose,
                _c)) },
            hideTitle ? null : React.createElement("span", { className: "c-alert__title ".concat(cssAlertTitle) }, getAlertTitleBasedOnType()),
            children),
        onClose && React.createElement("span", { className: 'c-alert__close', onClick: onClose })));
};
var ErrorAlert = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(AlertBase, __assign({}, props, { type: 'error' }), children));
};
var InfoAlert = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(AlertBase, __assign({}, props, { type: 'info' }), children));
};
var AttentionAlert = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(AlertBase, __assign({}, props, { type: 'attention' }), children));
};
var SuccessAlert = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(AlertBase, __assign({}, props, { type: 'success' }), children));
};
var WarningAlert = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(AlertBase, __assign({}, props, { type: 'warning' }), children));
};

export { AlertBase, AttentionAlert, ErrorAlert, InfoAlert, SuccessAlert, WarningAlert };
//# sourceMappingURL=index.js.map
